export default __webpack_public_path__ + "static/media/underdog_big.d71acf6a.jpg";